import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/request'

import ElementUI from 'element-plus'; //导入组件库
import 'element-plus/theme-chalk/index.css'; //导入组件相关样式


createApp(App).use(ElementUI).use(store).use(router).mount('#app')